import { Driver, MotorFunnelState } from '../types';

export const getReviewPolicyStartDate = (state: MotorFunnelState): string =>
  state.reviewDetails.policyStartDate;

export const getReviewMainDriver = (state: MotorFunnelState): Driver =>
  state.reviewDetails.mainDriver;

export const getReviewAdditionalDrivers = (state: MotorFunnelState): Driver[] =>
  state.reviewDetails.additionalDrivers;
